module.exports = __webpack_public_path__ + "static/media/admin-blue.efbf6146.svg";